export enum YmdPartitionColumn {
    Year = "year",
    Month = "month",
    Day = "day"
}